import { render, staticRenderFns } from "./r-world-region-dialog.vue?vue&type=template&id=1daad774"
import script from "./r-world-region-dialog.vue?vue&type=script&lang=js"
export * from "./r-world-region-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1daad774')) {
      api.createRecord('1daad774', component.options)
    } else {
      api.reload('1daad774', component.options)
    }
    module.hot.accept("./r-world-region-dialog.vue?vue&type=template&id=1daad774", function () {
      api.rerender('1daad774', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/world-region/r-world-region-dialog.vue"
export default component.exports